import React, { Fragment, useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { addTrailingSlash } from '../../utils/uriUtils';
import { supportedAmpLocales } from 'dibs-intl/exports/constants';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

import { SharedHeadTitleTag } from '../../shared/SharedHead/SharedHeadTitleTag';
import { SharedHeadMetaTags } from '../../shared/SharedHead/SharedHeadMetaTags';
import { SharedHeadScriptTags } from '../../shared/SharedHead/SharedHeadScriptTags';
import { SharedHeadLinkTags } from '../../shared/SharedHead/SharedHeadLinkTags';

function BuySharedHeadComponent({ buyPage, intlVariables, isAmp }) {
    const { metadata, edges: items } = buyPage;
    const { locale } = intlVariables;
    const additionalLinks = [];
    const { localeOrigin } = useContext(ServerVarsContext);

    if (
        supportedAmpLocales.includes(locale) &&
        !metadata.prev &&
        !isAmp &&
        !metadata.disableIndexing
    ) {
        const { canonical } = metadata;
        additionalLinks.push({
            rel: 'amphtml',
            href: addTrailingSlash(`${localeOrigin}/amp/${canonical}`),
        });
    }

    return (
        <Fragment>
            <SharedHeadTitleTag metadata={metadata} />
            <SharedHeadMetaTags metadata={metadata} items={items} />
            <SharedHeadScriptTags metadata={metadata} />
            <SharedHeadLinkTags metadata={metadata} additionalLinks={additionalLinks} />
        </Fragment>
    );
}

BuySharedHeadComponent.propTypes = {
    buyPage: PropTypes.object.isRequired,
    intlVariables: PropTypes.shape({
        locale: PropTypes.string,
    }).isRequired,
    isAmp: PropTypes.bool,
};

export const BuySharedHead = createFragmentContainer(
    connect(({ intlVariables }) => ({ intlVariables }))(BuySharedHeadComponent),
    {
        buyPage: graphql`
            fragment BuySharedHead_buyPage on BuyPageConnection {
                metadata {
                    canonical
                    disableIndexing
                    prev
                    ...SharedHeadTitleTag_metadata
                    ...SharedHeadMetaTags_metadata
                    ...SharedHeadScriptTags_metadata
                    ...SharedHeadLinkTags_metadata
                }
                edges {
                    node {
                        ...SharedHeadMetaTags_node @relay(mask: false)
                    }
                }
            }
        `,
    }
);
